import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'flowbite-react';
import { RouterProvider } from 'react-router';
import { ToastContainer } from 'react-toastify';

import '@src/configs/dayjs.configs';
import '@src/configs/i18n.configs';
import '@src/configs/sentry.configs';

import { ThemeInit } from '../.flowbite-react/init';
import { customTheme } from './configs/flowbite.configs';
import { queryClient } from './configs/tanstack.configs';
import { TOASTIFY_CONFIGS } from './configs/toastify.configs';
import { router } from './routes/router';

import './styles/index.css';

export const App = () => {
  return (
    <>
      <ThemeInit />
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={customTheme}>
          <ToastContainer {...TOASTIFY_CONFIGS} />
          <RouterProvider router={router} />
        </ThemeProvider>
      </QueryClientProvider>
    </>
  );
};
